<template>
  <form-section
    id="applicable_law_form"
    :headline="this.$t('form.applicableLaw.headline')"
  >
    <div class="inline-lg">
      <div class="form-check">
        <label>
          <input
            :value="true"
            v-model="applicableLaw.isCourt"
            type="radio"
            name="contractType"
            v-on:input="scrollTo('#applicable_law')"
          />
          {{ $t("form.applicableLaw.rule_types.court") }}
        </label>
      </div>
      <div class="form-check">
        <label>
          <input
            :value="false"
            v-model="applicableLaw.isCourt"
            type="radio"
            name="contractType"
            v-on:input="scrollTo('#applicable_law')"
          />
          {{ $t("form.applicableLaw.rule_types.voldgiftinstitut") }}
        </label>
      </div>
    </div>
  </form-section>
</template>

<script>
import FormSection from "@/shared/components/FormSection.vue";
import RadioGroup from "@/shared/components/RadioGroup.vue";

export default {
  components: {
    FormSection,
    RadioGroup,
  },
  data() {
    return {
      applicableLaw: {
        isCourt: null,
      },
    };
  },
  watch: {
    applicableLaw: {
      handler() {
        this.$store.commit("updateApplicableLaw", this.applicableLaw);
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/hemmelig/components/form/ApplicableLaw.vue